<div class="modal-header">
  <h5  *ngIf="emailSent" class="modal-title">
    {{"signin.Thank You for Registering" | translate}}
  </h5>
  <h5 *ngIf="!emailSent" class="modal-title" >{{"signin.Sign up" | translate}}</h5>
  <button
          type="button"
          class="close"
          (click)="onClose()"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
    </svg>
  </button>
</div>
<div class="modal-body pb-5" *ngIf="!emailSent">
  <button class="login-button  google-login"
          (click)="loginWithGoogle()">
    <span>
      {{"signin.Continue with Google" | translate}}

    </span>
    <img src="../assets/icons/google.png" alt="google-logo" />

  </button>
  <div class="w-100 or">
    {{"signin.or" | translate}}
  </div>
    <div class="form-control">
      <input [(ngModel)]="email" type="email" placeholder="Email" />
    </div>
    <button class="login-button" (click)="SignInWithEmailLink(email)">
      {{"signin.Sign up with email" | translate}}
    </button>
    <p><small>
      {{"signin.Link to login will be sent to your email" | translate}}
    </small></p>

</div>

<div class="modal-body" *ngIf="emailSent">
    <p class="text-center">
      {{"signin.We have sent a confirmation email to" | translate}}
      <strong>{{email}}</strong>.</p>
    <p class="text-center">
      {{"signin.Please check your email (including spam folder) and click on the link to verify your email address." | translate}}
    </p>
</div>
